export enum HelperMessageType {
    NONE,
    ERROR,
}

export interface HelperMessage {
    type: HelperMessageType,
    text?: string
}